import {AnyAction} from '@reduxjs/toolkit';
import * as Constants from '../constant/LeadImplantConstants';
import {produce} from 'immer';

export interface ICreateLeadImplant {
  serial_number: string;
  reference_id: number;
  implant_date: string;
  lead_location: string;
  patient_id: number | undefined;
}

export interface IResponseStatus {
  message: string
  error: string
  data: any
  status: number
}

const initialState = {}

const leadImplantReducer = produce((draft = initialState, action: AnyAction) => {
  switch (action.type) {
    case Constants.ADD_LEAD_IMPLANT_SUCCESS:
      break
    default:
        return draft
  }
})

export default leadImplantReducer
